(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afis-order-calculator"]) return;
  try {
    
if (!customElements.get('afis-order-calculator')) {
  class AfisOrderCalculator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      window.addEventListener('pageshow', () => { if (this.isConnected) this.calculate(); });
      this.material = this.querySelector('[data-material]');
      this.dimensions = this.querySelector('[data-dimensions]');
      this.dimensions.hidden = !this.material.value;
      this.material.setAttribute('aria-expanded', String(!!this.material.value));
      this.widthInput = this.querySelector('[data-width-input]');
      this.heightInput = this.querySelector('[data-height-input]');
      this.copiesInput = this.querySelector('[data-copies]');
      this.preset = this.querySelector('[data-preset]');
      this.updatePresetAvailability();
      this.error = this.querySelector('[data-error]');
      this.form = this.querySelector('.print-order__form');
      this.form.addEventListener('submit', (event) => {
        this.calculate();
        if (!this.nativeReady || this.dataset.nativeEnabled !== 'true') { event.preventDefault(); return; }
        this.widthInput.value = (Number(this.parseDimension(this.widthInput.value))/100).toString();
        this.heightInput.value = (Number(this.parseDimension(this.heightInput.value))/100).toString();
        this.querySelector('[data-configuration-id]').value = crypto.randomUUID();
        try { sessionStorage.removeItem('cart-count-print-aware'); } catch {}
        this.querySelector('[data-native-submit]').disabled = true;
      });
      this.money = new Intl.NumberFormat(this.dataset.locale || 'tr', {style:'currency',currency:'TRY'});
      this.number = new Intl.NumberFormat(this.dataset.locale || 'tr', {maximumFractionDigits:6});
      this.material.addEventListener('change', () => {
        this.dimensions.hidden = !this.material.value;
        this.material.setAttribute('aria-expanded', String(!!this.material.value));
        this.updatePresetAvailability();
        this.calculate();
      });
      this.preset.addEventListener('change', () => {
        if (this.preset.value !== 'custom') {
          const [width,height] = this.preset.value.split(',');
          this.widthInput.value = width;
          this.heightInput.value = height;
        }
        this.calculate();
      });
      for (const field of [this.widthInput,this.heightInput,this.copiesInput]) {
        field.addEventListener('input', () => {
          if (field !== this.copiesInput) this.preset.value = 'custom';
          this.calculate();
        });
      }
      this.calculate();
    }
    materialConfig() {
      return this.material.value === 'afis' ? { label:'Afiş Baskı' } : null;
    }
    updatePresetAvailability() {}
    parseDimension(value) {
      const normalized = value.trim().replace(',','.');
      if (normalized.length > 12) return null;
      if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) return null;
      const [whole,fraction=''] = normalized.split('.');
      const scaled = BigInt(whole) * 100n + BigInt(fraction.padEnd(2,'0'));
      if (scaled <= 0n || scaled > 100000000n) return null;
      return scaled;
    }
    reset(message='') {
      this.resetNative();
      this.querySelector('[data-area]').textContent = '—';
      this.querySelector('[data-total-area]').textContent = '—';
      this.querySelector('[data-billable-area]').textContent = '—';
      this.querySelector('[data-total]').textContent = '—';
      this.querySelector('[data-size-display]').textContent = this.dataset.paperEmpty;
      this.querySelector('[data-rotation]').hidden = true;
      this.error.textContent = message;
    }
    resetNative() {
      this.nativeReady = false;
      this.querySelector('[data-native-submit]').disabled = true;
      this.querySelector('[data-native-quantity]').value = '0';
      this.querySelector('[data-native-display]').textContent = '—';
      this.querySelector('[data-native-status]').textContent = this.dataset.nativeEnabled === 'true' ? this.dataset.nativeEmpty : this.dataset.nativeDisabled;
      for (const selector of ['[data-property-material]','[data-property-area]','[data-property-billable]']) this.querySelector(selector).value = '';
    }
    calculate() {
      this.resetNative();
      for (const field of [this.widthInput,this.heightInput,this.copiesInput]) field.removeAttribute('aria-invalid');
      if (!this.material.value) { this.reset(); return; }
      const material = this.materialConfig();
      if (!material) { this.reset(this.dataset.materialError); return; }
      if (!this.widthInput.value.trim() || !this.heightInput.value.trim()) { this.reset(this.dataset.empty); return; }
      const width = this.parseDimension(this.widthInput.value);
      const height = this.parseDimension(this.heightInput.value);
      const copiesText = this.copiesInput.value;
      const copies = copiesText.length < 9 && /^\d+$/.test(copiesText) ? BigInt(copiesText) : 0n;
      if (!width || !height || copies !== 1n) {
        this.reset(this.dataset.numberError);
        if (!width) this.widthInput.setAttribute('aria-invalid','true');
        if (!height) this.heightInput.setAttribute('aria-invalid','true');
        if (copies !== 1n) this.copiesInput.setAttribute('aria-invalid','true');
        return;
      }
      const widthCm = Number(width)/100;
      const heightCm = Number(height)/100;
      const rateCents = BigInt(Math.round(Number(this.dataset.rate)*100));
      const areaScaled = width * height;
      const totalAreaScaled = areaScaled * copies;
      const minimumScaled = BigInt(this.dataset.minimumUnits) * 10000n;
      const billableAreaScaled = totalAreaScaled < minimumScaled ? minimumScaled : totalAreaScaled;
      const cents = (billableAreaScaled * rateCents + 50000000n) / 100000000n;
      if (cents > BigInt(Number.MAX_SAFE_INTEGER)) { this.reset(this.dataset.numberError); return; }
      this.error.textContent = '';
      this.querySelector('[data-area]').textContent = this.number.format(Number(areaScaled)/100000000) + ' m²';
      this.querySelector('[data-total-area]').textContent = this.number.format(Number(totalAreaScaled)/100000000) + ' m²';
      this.querySelector('[data-billable-area]').textContent = this.number.format(Number(billableAreaScaled)/100000000) + ' m²';
      this.querySelector('[data-total]').textContent = this.money.format(Number(cents)/100);
      if (width % 100n !== 0n || height % 100n !== 0n) {
        this.querySelector('[data-native-status]').textContent = this.dataset.nativeDecimal;
      } else if (this.dataset.nativePrice !== '2' || rateCents !== 20000n) {
        this.querySelector('[data-native-status]').textContent = this.dataset.nativeMismatch;
      } else {
        const quantity = billableAreaScaled / 10000n;
        if (quantity > 2147483647n) {
          this.querySelector('[data-native-status]').textContent = this.dataset.nativeLimit;
        } else {
          this.nativeReady = true;
          this.querySelector('[data-native-quantity]').value = quantity.toString();
          this.querySelector('[data-native-display]').textContent = this.number.format(Number(quantity));
          this.querySelector('[data-property-material]').value = material.label;
          this.querySelector('[data-property-area]').value = (Number(totalAreaScaled)/100000000).toString();
          this.querySelector('[data-property-billable]').value = (Number(billableAreaScaled)/100000000).toString();
          this.querySelector('[data-native-submit]').disabled = this.dataset.nativeEnabled !== 'true';
          this.querySelector('[data-native-status]').textContent = this.dataset.nativeEnabled === 'true' ? this.dataset.nativeReady : this.dataset.nativeDisabled;
        }
      }
      this.querySelector('[data-rotation]').hidden = true;
      this.querySelector('[data-size-display]').textContent = this.number.format(widthCm)+' × '+this.number.format(heightCm)+' cm';
      const ratio = widthCm/heightCm;
      const mobile = window.matchMedia('(max-width:749px)').matches;
      const maxWidth = mobile ? 165 : 210;
      const maxHeight = mobile ? 75 : 130;
      const paper = this.querySelector('[data-paper]');
      paper.style.width = Math.min(maxWidth,maxHeight*ratio)+'px';
      paper.style.height = Math.min(maxHeight,maxWidth/ratio)+'px';
    }
  }
  customElements.define('afis-order-calculator', AfisOrderCalculator);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pg-video-carousel')) {
    customElements.define('pg-video-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (!this.slides.length) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.index = 0;
        this.resumeTime = 0;
        this.visible = false;
        this.mobile = matchMedia('(max-width: 749px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.enabled = this.dataset.autoplay === 'true' && !this.motion.matches;
        this.toggleButton = this.querySelector('[data-toggle]');
        this.status = this.querySelector('[data-status]');
        this.querySelectorAll('[data-js-control]').forEach(element => { element.hidden = false; });
        this.querySelector('[data-previous]').addEventListener('click', () => this.select(this.index - 1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.select(this.index + 1, true), options);
        this.querySelectorAll('[data-select]').forEach(button => button.addEventListener('click', () => this.select(Number(button.dataset.select), true), options));
        this.toggleButton.addEventListener('click', () => {
          this.enabled = !this.enabled;
          this.status.textContent = '';
          if (this.enabled && this.slides[this.index].dataset.failed) this.release(this.slides[this.index]);
          this.update();
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        }, options);
        this.slides.forEach((slide, index) => {
          const video = slide.querySelector('video');
          video.muted = true;
          video.addEventListener('playing', () => { if (index === this.index) slide.dataset.ready = 'true'; }, options);
          video.addEventListener('loadedmetadata', () => {
            if (index === this.index && this.resumeTime > 0) {
              video.currentTime = Math.min(this.resumeTime, Math.max(0, video.duration - 0.1));
              this.resumeTime = 0;
            }
          }, options);
          video.addEventListener('ended', () => {
            if (index !== this.index || !this.enabled) return;
            if (this.motion.matches) { this.enabled = false; this.update(); }
            else this.select(this.index + 1, false);
          }, options);
          video.addEventListener('error', () => {
            if (index !== this.index || !video.getAttribute('src')) return;
            slide.dataset.failed = 'true';
            slide.dataset.ready = 'false';
            this.enabled = false;
            this.status.textContent = this.dataset.error;
            this.update();
          }, options);
        });
        this.mobile.addEventListener('change', () => {
          const slide = this.slides[this.index];
          this.resumeTime = this.resumeTime || slide.querySelector('video').currentTime || 0;
          this.release(slide);
          this.update();
        }, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.enabled = false;
          this.update();
        }, options);
        document.addEventListener('visibilitychange', () => this.update(), options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.contains(event.target));
          if (index >= 0) { this.enabled = false; this.select(index, false); }
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        }, { threshold: 0.15 });
        this.observer.observe(this.querySelector('.pg-cinema__stage'));
        this.select(0, false);
      }
      release(slide) {
        this.playToken = (this.playToken || 0) + 1;
        const video = slide.querySelector('video');
        video.pause();
        if (video.getAttribute('src')) { video.removeAttribute('src'); video.load(); }
        slide.dataset.ready = 'false';
        delete slide.dataset.failed;
      }
      select(index, manual) {
        const next = (index + this.slides.length) % this.slides.length;
        if (next !== this.index) { this.release(this.slides[this.index]); this.resumeTime = 0; }
        this.index = next;
        this.slides.forEach((slide, position) => { slide.hidden = position !== next; });
        const current = this.slides[next];
        this.querySelector('[data-current-link]').href = current.dataset.link;
        this.querySelector('[data-current-label]').textContent = current.dataset.cta;
        this.querySelectorAll('[data-select]').forEach(button => {
          if (Number(button.dataset.select) === next) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        this.status.textContent = manual ? current.dataset.title + ' · ' + (next + 1) + ' / ' + this.slides.length : '';
        this.update();
      }
      update() {
        if (!this.slides || !this.abort) return;
        this.playToken = (this.playToken || 0) + 1;
        const current = this.slides[this.index];
        const video = current.querySelector('video');
        const shouldPlay = this.enabled && this.visible && !document.hidden;
        this.toggleButton.setAttribute('aria-label', this.enabled ? this.dataset.pause : this.dataset.play);
        this.querySelector('[data-play-icon]').toggleAttribute('hidden', this.enabled);
        this.querySelector('[data-pause-icon]').toggleAttribute('hidden', !this.enabled);
        if (!shouldPlay) { video.pause(); return; }
        const source = this.mobile.matches ? current.dataset.mobile : current.dataset.desktop;
        if (!source) { this.enabled = false; this.status.textContent = this.dataset.error; this.update(); return; }
        if (video.getAttribute('src') !== source) { video.src = source; video.load(); }
        if (video.ended) video.currentTime = 0;
        const expectedIndex = this.index;
        const expectedToken = this.playToken;
        video.play().catch(() => {
          if (this.playToken !== expectedToken || this.index !== expectedIndex || !this.enabled || !this.visible || document.hidden) return;
          this.enabled = false;
          this.update();
        });
      }
      disconnectedCallback() {
        if (!this.abort) return;
        this.abort.abort();
        this.observer.disconnect();
        this.slides.forEach(slide => this.release(slide));
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-order-calculator"]) return;
  try {
    
if (!customElements.get('print-order-calculator')) {
  class PrintOrderCalculator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      window.addEventListener('pageshow', () => { if (this.isConnected) this.calculate(); });
      this.material = this.querySelector('[data-material]');
      this.dimensions = this.querySelector('[data-dimensions]');
      this.dimensions.hidden = !this.material.value;
      this.material.setAttribute('aria-expanded', String(!!this.material.value));
      this.widthInput = this.querySelector('[data-width-input]');
      this.heightInput = this.querySelector('[data-height-input]');
      this.copiesInput = this.querySelector('[data-copies]');
      this.preset = this.querySelector('[data-preset]');
      this.updatePresetAvailability();
      this.error = this.querySelector('[data-error]');
      this.form = this.querySelector('.print-order__form');
      this.form.addEventListener('submit', (event) => {
        this.calculate();
        if (!this.nativeReady || this.dataset.nativeEnabled !== 'true') { event.preventDefault(); return; }
        this.widthInput.value = (Number(this.parseDimension(this.widthInput.value))/100).toString();
        this.heightInput.value = (Number(this.parseDimension(this.heightInput.value))/100).toString();
        this.querySelector('[data-configuration-id]').value = crypto.randomUUID();
        try { sessionStorage.removeItem('cart-count-print-aware'); } catch {}
        this.querySelector('[data-native-submit]').disabled = true;
      });
      this.money = new Intl.NumberFormat(this.dataset.locale || 'tr', {style:'currency',currency:'TRY'});
      this.number = new Intl.NumberFormat(this.dataset.locale || 'tr', {maximumFractionDigits:6});
      this.material.addEventListener('change', () => {
        this.dimensions.hidden = !this.material.value;
        this.material.setAttribute('aria-expanded', String(!!this.material.value));
        this.updatePresetAvailability();
        this.calculate();
      });
      this.preset.addEventListener('change', () => {
        if (this.preset.value !== 'custom') {
          const [width,height] = this.preset.value.split(',');
          this.widthInput.value = width;
          this.heightInput.value = height;
        }
        this.calculate();
      });
      for (const field of [this.widthInput,this.heightInput,this.copiesInput]) {
        field.addEventListener('input', () => {
          if (field !== this.copiesInput) this.preset.value = 'custom';
          this.calculate();
        });
      }
      this.calculate();
    }
    materialConfig() {
      if (this.material.value === 'five_metre') return { label:'Tek parça 5 metre baskı', exclusive:false };
      if (this.material.value === 'below_five_metre') return { label:'5 metrenin altındaki baskılar', exclusive:true };
      return null;
    }
    updatePresetAvailability() {
      const material = this.materialConfig();
      for (const option of Array.from(this.preset.options || [])) {
        const [width,height] = option.value.split(',').map(Number);
        option.disabled = !!material && option.value !== 'custom' && (material.exclusive ? Math.min(width,height) >= 500 : Math.min(width,height) > 500);
        if (option.disabled && this.preset.value === option.value) this.preset.value = 'custom';
      }
    }
    parseDimension(value) {
      const normalized = value.trim().replace(',','.');
      if (normalized.length > 12) return null;
      if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) return null;
      const [whole,fraction=''] = normalized.split('.');
      const scaled = BigInt(whole) * 100n + BigInt(fraction.padEnd(2,'0'));
      if (scaled <= 0n || scaled > 100000000n) return null;
      return scaled;
    }
    reset(message='') {
      this.resetNative();
      this.querySelector('[data-area]').textContent = '—';
      this.querySelector('[data-total-area]').textContent = '—';
      this.querySelector('[data-billable-area]').textContent = '—';
      this.querySelector('[data-total]').textContent = '—';
      this.querySelector('[data-size-display]').textContent = this.dataset.paperEmpty;
      this.querySelector('[data-rotation]').hidden = true;
      this.error.textContent = message;
    }
    resetNative() {
      this.nativeReady = false;
      this.querySelector('[data-native-submit]').disabled = true;
      this.querySelector('[data-native-quantity]').value = '0';
      this.querySelector('[data-native-display]').textContent = '—';
      this.querySelector('[data-native-status]').textContent = this.dataset.nativeEnabled === 'true' ? this.dataset.nativeEmpty : this.dataset.nativeDisabled;
      for (const selector of ['[data-property-material]','[data-property-area]','[data-property-billable]']) this.querySelector(selector).value = '';
    }
    calculate() {
      this.resetNative();
      for (const field of [this.widthInput,this.heightInput,this.copiesInput]) field.removeAttribute('aria-invalid');
      if (!this.material.value) { this.reset(); return; }
      const material = this.materialConfig();
      if (!material) { this.reset(this.dataset.materialError); return; }
      if (!this.widthInput.value.trim() || !this.heightInput.value.trim()) { this.reset(this.dataset.empty); return; }
      const width = this.parseDimension(this.widthInput.value);
      const height = this.parseDimension(this.heightInput.value);
      const copiesText = this.copiesInput.value;
      const copies = copiesText.length < 9 && /^\d+$/.test(copiesText) ? BigInt(copiesText) : 0n;
      if (!width || !height || copies !== 1n) {
        this.reset(this.dataset.numberError);
        if (!width) this.widthInput.setAttribute('aria-invalid','true');
        if (!height) this.heightInput.setAttribute('aria-invalid','true');
        if (copies !== 1n) this.copiesInput.setAttribute('aria-invalid','true');
        return;
      }
      const rollWidth = 500;
      const widthCm = Number(width)/100;
      const heightCm = Number(height)/100;
      if (material.exclusive ? Math.min(widthCm,heightCm) >= rollWidth : Math.min(widthCm,heightCm) > rollWidth) {
        this.reset(material.exclusive ? this.dataset.underWidthError : this.dataset.widthError.replace('WIDTH',this.number.format(rollWidth)));
        this.widthInput.setAttribute('aria-invalid','true');
        this.heightInput.setAttribute('aria-invalid','true');
        return;
      }
      const rateCents = BigInt(Math.round(Number(this.dataset.rate)*100));
      const areaScaled = width * height;
      const totalAreaScaled = areaScaled * copies;
      const billableAreaScaled = totalAreaScaled < 100000000n ? 100000000n : totalAreaScaled;
      const cents = (billableAreaScaled * rateCents + 50000000n) / 100000000n;
      if (cents > BigInt(Number.MAX_SAFE_INTEGER)) { this.reset(this.dataset.numberError); return; }
      this.error.textContent = '';
      this.querySelector('[data-area]').textContent = this.number.format(Number(areaScaled)/100000000) + ' m²';
      this.querySelector('[data-total-area]').textContent = this.number.format(Number(totalAreaScaled)/100000000) + ' m²';
      this.querySelector('[data-billable-area]').textContent = this.number.format(Number(billableAreaScaled)/100000000) + ' m²';
      this.querySelector('[data-total]').textContent = this.money.format(Number(cents)/100);
      if (width % 100n !== 0n || height % 100n !== 0n) {
        this.querySelector('[data-native-status]').textContent = this.dataset.nativeDecimal;
      } else if (this.dataset.nativePrice !== '4' || rateCents !== 40000n) {
        this.querySelector('[data-native-status]').textContent = this.dataset.nativeMismatch;
      } else {
        const quantity = billableAreaScaled / 10000n;
        if (quantity > 2147483647n) {
          this.querySelector('[data-native-status]').textContent = this.dataset.nativeLimit;
        } else {
          this.nativeReady = true;
          this.querySelector('[data-native-quantity]').value = quantity.toString();
          this.querySelector('[data-native-display]').textContent = this.number.format(Number(quantity));
          this.querySelector('[data-property-material]').value = material.label;
          this.querySelector('[data-property-area]').value = (Number(totalAreaScaled)/100000000).toString();
          this.querySelector('[data-property-billable]').value = (Number(billableAreaScaled)/100000000).toString();
          this.querySelector('[data-native-submit]').disabled = this.dataset.nativeEnabled !== 'true';
          this.querySelector('[data-native-status]').textContent = this.dataset.nativeEnabled === 'true' ? this.dataset.nativeReady : this.dataset.nativeDisabled;
        }
      }
      this.querySelector('[data-rotation]').hidden = material.exclusive ? widthCm < rollWidth : widthCm <= rollWidth;
      this.querySelector('[data-size-display]').textContent = this.number.format(widthCm)+' × '+this.number.format(heightCm)+' cm';
      const ratio = widthCm/heightCm;
      const mobile = window.matchMedia('(max-width:749px)').matches;
      const maxWidth = mobile ? 165 : 210;
      const maxHeight = mobile ? 75 : 130;
      const paper = this.querySelector('[data-paper]');
      paper.style.width = Math.min(maxWidth,maxHeight*ratio)+'px';
      paper.style.height = Math.min(maxHeight,maxWidth/ratio)+'px';
    }
  }
  customElements.define('print-order-calculator', PrintOrderCalculator);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-size-planner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('print-size-planner')) {
    class PrintSizePlanner extends HTMLElement {
      static dimension(value) {
        const raw = String(value ?? '').trim();
        if (!raw) return { valid: false, reason: 'empty' };
        if (/^\d+[.,]\d{3,}$/.test(raw)) return { valid: false, reason: 'precision' };
        if (!/^\d+(?:[.,]\d{1,2})?$/.test(raw)) return { valid: false, reason: 'number' };
        const [whole, fraction = ''] = raw.replace(',', '.').split('.');
        const units = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
        return units > 0n ? { valid: true, units } : { valid: false, reason: 'number' };
      }

      static decimal(units, scale) {
        const digits = units.toString().padStart(scale + 1, '0');
        const whole = scale ? digits.slice(0, -scale) : digits;
        const fraction = scale ? digits.slice(-scale).replace(/0+$/, '') : '';
        return fraction ? `${whole}.${fraction}` : whole;
      }

      static presetsForType(presets, typeKey, hasTypes) {
        return presets.filter((preset) => hasTypes ? typeKey !== '' && preset.dataset.typeKey === typeKey : !preset.dataset.typeKey);
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.typeSelect = this.querySelector('[data-type]');
        this.presetSelect = this.querySelector('[data-preset]');
        this.customFields = this.querySelector('[data-custom]');
        this.widthInput = this.querySelector('[data-width-input]');
        this.heightInput = this.querySelector('[data-height-input]');
        this.error = this.querySelector('[data-error]');
        this.areaOutput = this.querySelector('[data-area]');
        this.sizeOutput = this.querySelector('[data-selected-size]');
        this.typeOutput = this.querySelector('[data-selected-type]');
        this.typeNote = this.querySelector('[data-type-note]');
        this.presetOptions = [...this.presetSelect.querySelectorAll('[data-preset-option]')];
        this.emptyOption = this.presetSelect.querySelector('option[value=""]');
        this.customOption = this.presetSelect.querySelector('option[value="custom"]');
        try {
          this.number = new Intl.NumberFormat(this.dataset.locale || 'tr');
        } catch {
          this.number = new Intl.NumberFormat('tr');
        }
        this.decimalMark = this.number.formatToParts(1.1).find((part) => part.type === 'decimal')?.value || '.';
        this.typeSelect?.addEventListener('change', () => this.filterPresets());
        this.presetSelect.addEventListener('change', () => this.selectPreset());
        this.widthInput.addEventListener('input', () => this.calculate());
        this.heightInput.addEventListener('input', () => this.calculate());
        this.filterPresets();
      }

      format(units, scale) {
        const [whole, fraction] = PrintSizePlanner.decimal(units, scale).split('.');
        return this.number.format(BigInt(whole)) + (fraction ? this.decimalMark + fraction : '');
      }

      filterPresets() {
        const typeKey = this.typeSelect?.value || '';
        const matches = PrintSizePlanner.presetsForType(this.presetOptions, typeKey, Boolean(this.typeSelect));
        for (const option of matches) {
          const width = PrintSizePlanner.dimension(option.dataset.width);
          const height = PrintSizePlanner.dimension(option.dataset.height);
          option.disabled = !width.valid || !height.valid;
          if (width.valid && height.valid) {
            const dimensions = this.dataset.sizePattern.replace('WIDTH', this.format(width.units, 2)).replace('HEIGHT', this.format(height.units, 2));
            option.textContent = option.dataset.label ? `${option.dataset.label} · ${dimensions}` : dimensions;
          }
        }
        this.presetSelect.replaceChildren(this.emptyOption, ...matches, this.customOption);
        this.presetSelect.disabled = Boolean(this.typeSelect) && !typeKey;
        this.presetSelect.value = '';
        this.widthInput.value = '';
        this.heightInput.value = '';
        if (this.typeSelect) {
          const selected = this.typeSelect.selectedOptions[0];
          this.typeOutput.textContent = typeKey ? selected.textContent : this.dataset.empty;
          this.typeNote.textContent = typeKey ? selected.dataset.note || '' : '';
          this.typeNote.hidden = !this.typeNote.textContent;
        }
        this.selectPreset();
      }

      selectPreset() {
        const isCustom = this.presetSelect.value === 'custom';
        this.customFields.hidden = !isCustom;
        this.widthInput.disabled = !isCustom;
        this.heightInput.disabled = !isCustom;
        this.calculate();
      }

      calculate() {
        this.error.textContent = '';
        this.error.hidden = true;
        this.widthInput.removeAttribute('aria-invalid');
        this.heightInput.removeAttribute('aria-invalid');
        this.areaOutput.textContent = this.dataset.empty;
        this.sizeOutput.textContent = this.dataset.empty;
        if (this.presetSelect.disabled || !this.presetSelect.value) return;
        const selected = this.presetSelect.selectedOptions[0];
        const isCustom = this.presetSelect.value === 'custom';
        const width = PrintSizePlanner.dimension(isCustom ? this.widthInput.value : selected.dataset.width);
        const height = PrintSizePlanner.dimension(isCustom ? this.heightInput.value : selected.dataset.height);
        const invalid = [width, height].find((dimension) => !dimension.valid && dimension.reason !== 'empty');
        if (invalid) {
          this.error.textContent = invalid.reason === 'precision' ? this.dataset.precisionError : this.dataset.numberError;
          this.error.hidden = false;
          if (isCustom && !width.valid && width.reason !== 'empty') this.widthInput.setAttribute('aria-invalid', 'true');
          if (isCustom && !height.valid && height.reason !== 'empty') this.heightInput.setAttribute('aria-invalid', 'true');
        }
        if (!width.valid || !height.valid) return;
        this.sizeOutput.textContent = this.dataset.sizePattern.replace('WIDTH', this.format(width.units, 2)).replace('HEIGHT', this.format(height.units, 2));
        this.areaOutput.textContent = `${this.format(width.units * height.units, 8)} ${this.dataset.squareMetres}`;
      }
    }
    customElements.define('print-size-planner', PrintSizePlanner);
  }

  } catch(e) { console.error(e); }
})();
})();
